import React from 'react';

export function Select({ value, onValueChange, children, className }) {
  return (
    <select 
      value={value} 
      onChange={(e) => onValueChange(e.target.value)} 
      className={`form-select ${className || ''}`}
      style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} // Add basic styling default
    >
      {children}
    </select>
  );
}

export function SelectTrigger({ children, className }) {
  return <>{children}</>;
}

export function SelectContent({ children }) {
  return <>{children}</>;
}

export function SelectItem({ value, children }) {
  return <option value={value}>{children}</option>;
}

export function SelectValue({ children }) {
    return <>{children}</>;
}
